<template>
  <div class="block__day">
    <div v-if="loading" class="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
    <div v-else class="block__grid" :class="size">
      <Block v-for="time in times" :key="time + 'bk'" :time="time" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Block from "./BlockDateCardBlock";

export default {
  props: ["startTime"],
  data() {
    return {
      loading: true,
      size: "",
      times: []
    };
  },
  mounted() {
    this.initBlocks();
  },
  components: {
    Block
  },
  computed: {
    ...mapGetters(["setting"])
  },
  methods: {
    ...mapActions(["renderDay", "set"]),
    async initBlocks() {
      await this.renderDay(this.startTime);
      for (
        let time = this.startTime;
        time < this.startTime + 24 * 60 * 60 * 1000;
        time += parseInt(this.setting.block.size) * 60 * 1000
      ) {
        this.times.push(time);
      }
      this.size = this.getSize();

      this.loading = false;
    },
    //计算Size类
    getSize() {
      const size = parseInt(this.setting.block.size);
      switch (size) {
        case 5:
          return "block-min";
        case 15:
          return "block-med";
        default:
          return "block-max";
      }
    }
  }
};
</script>

<style>
.loading {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  padding: 30px 50px;
  height: 100%;
  width: 100%;
}

.block__day {
  flex: 1;
  /* display: grid; */
}

.block__grid {
  display: grid;
  height: 100%;
  width: 100%;
}

/* 5分钟 */
.block-min {
  grid-template-columns: repeat(12, minmax(40px, 1fr));
  grid-template-rows: repeat(24, minmax(22px, 1fr));
}

/* 15分钟 */
.block-med {
  grid-template-columns: repeat(4, minmax(45px, 1fr));
  grid-template-rows: repeat(24, minmax(22px, 1fr));
}

/* 30分钟 */
.block-max {
  grid-template-columns: repeat(2, minmax(90px, 1fr));
  grid-template-rows: repeat(24, minmax(22px, 1fr));
}
</style>
